import { useDispatch, useSelector } from "react-redux";
import MainBody from './indexBodyMobile';
import LogoTypography from '../../../../styles/images/brand/typography.svg';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import {Navigation, Pagination, EffectFade, Autoplay, Scrollbar, A11y} from 'swiper/modules';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { handleChangeDataHeaderMobile } from '../../../../redux/actions/partials/header/headerMobile';





const MainMobile = () => {

	const dispatch = useDispatch();

	const { topBanners } = useSelector(state => state.headerDesktop);

	const showSheetSearch = () => {
		dispatch(handleChangeDataHeaderMobile('isSheetSearchOpen', true));
	};


    return (

    	<div className="flex flex-col grow">
    		{/* az inja header mobile shoru mishe */}
    		<div className="fixed z-5 top-0 left-0 w-full z-3 bg-neutral-000">

    		</div>
    		<div></div>
    		<div>
    			<Swiper
                    className="hideNextPrev"
                    modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
                    slidesPerView="auto"
                    pagination={{clickable: true}}
                    loop={true}
                    autoplay={{
                        delay: 3000,       // هر چند میلی‌ثانیه یک‌بار اسلاید عوض شود
                        disableOnInteraction: false,  // اگر کاربر اسلاید را لمس کند، autoplay متوقف نشود
                    }}
                    navigation
                    style={{ width: "100%" }}
                    spaceBetween={0} >
                    {
                        topBanners.map((banner, key) => (
                            <SwiperSlide  key={`top-banner-${key}`}>
                                <a href={banner.url ? banner.url : '#'} onClick={(e) => {if(e.currentTarget.getAttribute('href') === '#'){e.preventDefault();}}} target="_blank" className="block">
                                    <div className="w-full h-[35px] md:h-[60px] bg-[rgba(0,0,0,0.04)] flex justify-center items-center">
                                        <div style={{height: '35px', lineHeight: '0'}}>
                                            <picture>
                                                <LazyLoadImage className="w-full inline-block" src={banner.image} height="35" alt={banner.title} title={banner.title} style={{objectFit: 'cover'}} />
                                            </picture>
                                        </div>
                                    </div>
                                </a>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
    		</div>

    		<div className="sticky top-0 left-0 w-full z-3 bg-neutral-000" style={{top: '0'}}>
    			<div>
					<header className="px-4 lg:py-2 py-3 relative flex items-start z-5 bg-neutral-000 shadow-none border-solid border-b-[1px] border-0 border-neutral-100 shadow-1-bottom">
						<div className="relative ml-0 w-full">
							<div className="w-full">
								<div>
									<div className="flex justify-between items-center">
										<div className="flex-1 BaseLayoutSearch_BaseLayoutSearch__QHPTB">
											<div data-cro-id="searchbox-click" className="flex items-center SearchInput_SearchInput__HB9qi SearchInput_SearchInput__searchInput__CEpaj ellipsis rounded-md bg-neutral-100 h-10 border-none bg-neutral-100 grow px-0 lg:px-4 text-body-2">
												<div className="w-full rounded-full !rounded-md">
													<div className="flex items-center justify-between grow min-w-0 h-9 px-3">
														<div className="flex cursor-pointer">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																<use xlinkHref="#searchSearch"></use>
															</svg>
														</div>
														<span onClick={showSheetSearch} data-cro-id="searchbox-type" className="grow px-2 lg:px-4 h-10 ellipsis">
															<div className="lg:text-body-2 text-button-1 flex items-center h-full text-body-2 text-neutral-500">
																<div className="flex gap-1 items-center">
																	<span className="lg:text-subtitle text-button-1 text-neutral-500 opacity-70">جستجو در
																	</span>
																	<div style={{width: '61px', height: '16px', lineHeight: '0'}}>
																		<img className="w-full inline-block" src={LogoTypography} width="61" height="16" alt="کوچی" title="" style={{objectFit: 'contain'}} />
																	</div>
																</div>
															</div>
															<div className="absolute top-2 right-13 flex">
															</div>
														</span>
														{/*<div className="flex cursor-pointer">
															<div className="cube-font-icon" data-icon-name="cube-action-ai-photo" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-ai-500)'}}>
															</div>
														</div>*/}
													</div>
												</div>
											</div>
										</div>
										{/* <a className="mr-2 bg-neutral-100 rounded-full overflow-hidden relative p-2 cursor-pointer flex justify-center items-center shrink-0" href="/profile/notification/">
											<div className="flex">
												<div className="cube-font-icon" data-icon-name="cube-alert-notification-outline" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
												</div>
											</div>
											<div className="bg-neutral-100 absolute top-0 right-0.5 p-[9px] bg-neutral-000">
											</div>
											<div className="flex absolute top-0 right-0.5">
												<div className="cube-font-icon" data-icon-name="cube-content-dot" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-primary)'}}>
												</div>
											</div>
										</a> */}
									</div>
								</div>
								<div className="z-4 text-body-2 styles_Tooltip__tooltip___Mj8o !right-6 !top-[-2px] styles_Tooltip__tooltip__arrow--bottom__rZ4eR styles_Tooltip__tooltip--hasArrow___6xzR styles_Tooltip__tooltip--inactive__vFMA1" data-popper-reference-hidden="false" data-popper-escaped="false" data-popper-placement="bottom" style={{position: 'absolute', inset: '0px auto auto 0px', transform: 'translate3d(230px, 87px, 0px)'}}>
									<div className="flex items-center">
										<span>ویژگی‌های محصولت رو توصیف کن، مثل رنگ و جنس تا پیداش کنیم.
										</span>
										<div className="flex cursor-pointer">
											<div className="cube-font-icon" data-icon-name="cube-nav-close" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-white)'}}>
											</div>
										</div>
									</div>
									<div>
									</div>
								</div>
							</div>
							{/*<div className="relative transition-all duration-100 overscroll-none">
								<div className="mt-3.5 mb-0.5 flex gap-1.5 items-center relative transition-all duration-100 overscroll-none">
									<div className="flex items-center justify-between gap-2 text-body-1">
										<div className="flex">
											<div className="cube-font-icon" data-icon-name="cube-location-pin" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
											</div>
										</div><p>ارسال به استان فارس، شهر شیراز</p>
									</div>
									<div className="flex">
										<div className="cube-font-icon" data-icon-name="cube-nav-chevron-left" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}}>
										</div>
									</div>
								</div>
							</div> */}
						</div>
					</header>
				</div>
    		</div>
    		{/* inja header mobile tamoom mishe */}


    		<div className="grow flex flex-col" style={{paddingBottom: '55px', paddingTop: '0'}}>
    			<div className="styles_BaseLayoutMobile__fixMobileHeader__eilSC">
    				<div className="base_layout_mobile_static_header">

    				</div>
    			</div>
    			<div className="grow bg-neutral-000 flex flex-col styles_BaseLayoutMobile__content__JgqoX">

    				<MainBody />

    			</div>
    		</div>




    	</div>


    );
}

export default MainMobile;